export default {
  name: 'Container'
};